"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.MessageBlock = void 0;
require("./MessageBlock.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _getMessageIcon = require("../../util/getMessageIcon/getMessageIcon");
var _renderObject = require("../../util/renderObject/renderObject");
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // utils
/**
 * MessageBlock
 * A dismissible, multi-line message block with optional actions and media.
 */
const MessageBlock = props => {
  const {
    messageType = defaultProps.messageType,
    // 'error' | 'warning' | 'info' | 'success'
    variant = defaultProps.variant,
    // 'default' | 'secondary' | 'compact'
    title,
    description,
    iconName,
    actionGroups,
    externalCloseActionElement,
    children,
    // media/content slot (e.g., image, custom node)
    className,
    // optional extra class
    ...rest
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-MessageBlock', `pal-c-MessageBlock--${messageType}`, `pal-c-MessageBlock__variant--${variant}`, className);
  const isCompact = variant === 'compact';
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassName
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageBlock__icon"
  }, (0, _getMessageIcon.getMessageIcon)(iconName, messageType, 'lg')), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageBlock__body"
  }, title && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label",
    htmlTag: "p",
    className: "pal-c-MessageBlock__title"
  }, title), !isCompact && description && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    className: "pal-c-MessageBlock__description"
  }, description), actionGroups && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageBlock__actions"
  }, (0, _renderObject.renderObject)(actionGroups)), !isCompact && children && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageBlock__children"
  }, children)), externalCloseActionElement && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-MessageBlock__close"
  }, (0, _renderObject.renderObject)(externalCloseActionElement)));
};

/**
 * Property type definitions
 * @typedef MessageBlockProps
 * @type {object}
 * @property {string} messageType - 'error' | 'warning' | 'info' | 'success'
 * @property {string} variant - 'default' | 'secondary' | 'compact'
 * @property {string} iconName - Optional icon override
 * @property {string} title - Title line
 * @property {string} description - Description copy
 * @property {object} actionGroups - Primary action group component
 * @property {object} externalCloseActionElement - close action component coming from web-site
 * @property {object} children - Media slot (e.g., image)
 * @property {string} className - Extra className
 */
exports.MessageBlock = MessageBlock;
const propTypes = exports.propTypes = {
  /** 'error' | 'warning' | 'info' | 'success' */
  messageType: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  /** 'default' | 'secondary' | 'compact' */
  variant: _propTypes.default.oneOf(['default', 'secondary', 'compact']),
  /** Optional icon override */
  iconName: _propTypes.default.string,
  /** Title line */
  title: _propTypes.default.string,
  /** Description copy */
  description: _propTypes.default.string,
  /** Primary action group component */
  actionGroups: _propTypes.default.node,
  /** Close button callback; when provided, close button is shown */
  externalCloseActionElement: _propTypes.default.node,
  /** Media slot (e.g., image) */
  children: _propTypes.default.node,
  /** Extra className */
  className: _propTypes.default.string
};
MessageBlock.propTypes = propTypes;

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} messageType='info' - sets the message type ('error', 'warning', 'info', 'success')
 * @property {string} variant='default' - sets the variant ('default', 'secondary', 'compact')
 */

const defaultProps = exports.defaultProps = {
  messageType: 'info',
  variant: 'default'
};
var _default = exports.default = MessageBlock;